/**
 * The DASH MP4 Protection Scheme schemeIdUri.
 *
 * @beta
 */
export const MP4_PROTECTION_SCHEME = 'urn:mpeg:dash:mp4protection:2011'
